import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { OldStudentSigphUploadPopupComponent } from '../old-student-sigph-upload-popup/old-student-sigph-upload-popup.component';
import { MatDialog } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'app-old-student-sigph-upload',
  templateUrl: './old-student-sigph-upload.component.html',
  styleUrls: ['./old-student-sigph-upload.component.scss']
})
export class OldStudentSigphUploadComponent implements OnInit {

  studentDataForm: FormGroup;
  studentDataList: any;
  CourseList: any;
  filteredListCourse: any;
  constructor(private dialog: MatDialog, private fb: FormBuilder,
    private modalPopupService: ModalpopService,
    public umsService: UmsService, private spinner: NgxSpinnerService) { }

  userPermission: any;
  UserCollege: any;
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 20];
  currentPage = 1;
  totalItems = 0;

  ngOnInit(): void {
    this.userPermission = JSON.parse(sessionStorage.getItem('userPermission'));
    this.studentDataForm = this.fb.group({
      CoCode: new FormControl(''),
    })
    this.getstudentdata();
    //  this.fetchCourse();
  }
  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    const newPageIndex = event.pageIndex + 1;
    this.currentPage = newPageIndex;
    this.getstudentdata();
  }

  updatePhotoSign(student, value) {
    const dialogRef = this.dialog.open(OldStudentSigphUploadPopupComponent, {
      width: '100%',
      data: {
        selected: student,
        key: value
      },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {

    });
  }

  searchStudent(keyword: string) {
    const stuId = keyword;

    let payload = {
      PageSize: this.pageSize,
      PageNumber: 1,
      CgCode: '',
      CoCode: '',
      StuRgNo: stuId
    };

    this.umsService.oldtudentData(payload).subscribe(res => {
      if (res.status) {
        this.studentDataList = res.data;
        this.totalItems = res.data[0]?.TotalRecords || res.data.length;
      } else {
        this.studentDataList = [];
        this.totalItems = 0;
      }
    });
  }


  getstudentdata() {
    if (this.userPermission[0].CgUi == 'C') {
      this.UserCollege = this.userPermission[0].CgId;
    }
    else {
      this.UserCollege = ''
    }
    this.spinner.show();
    const payload = {};
    payload['PageSize'] = this.pageSize;
    payload['PageNumber'] = this.currentPage;
    payload['CgCode'] = this.UserCollege;
    payload['CoCode'] = this.studentDataForm.value.CoCode ? this.studentDataForm.value.CoCode : '';
    this.umsService.oldtudentData(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        this.studentDataList = res.data;
        this.totalItems = res.data[0].TotalRecords;

      } else {
        this.spinner.hide();
        this.studentDataList = []
        this.totalItems = 0;
      }

    })
  }
}
